"use client"
import styled from "@emotion/styled"
import {
    Attribute,
    LocatorStationsWrapper
} from "api"
import { useLocale } from "next-intl"

import MapComponent from "map-feature/MapComponent"
import {
    CustomBreadcrumbs,
    HomeIcon,
    TitleWithLine,
    useIsDesktop
} from "ui"

const StyledContainer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`

const StyledCont = styled.div`
  padding-bottom: 0px;
  padding-top: '0px';
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export type LocatorProps = {
    metadata: Attribute[]
    stations: LocatorStationsWrapper
}

export interface UserLocation {
    lat: number;
    lon: number;
}

export function ServiceLocatorMap({ metadata, stations }: LocatorProps) {

    const locale = useLocale()
    const isDesktop = useIsDesktop()

    return (
        <StyledContainer>
            <CustomBreadcrumbs
                locale={locale}
                current={{
                    title: locale === "en" ? "Locator" : "איתור תחנות ושרותים",
                    url: `/`,
                }}
                parents={[{ title: <HomeIcon />, url: "/" }]}
            />
            <StyledCont>
                <TitleWithLine
                    title="איתור תחנות ושירותים"
                    titleColor="#000"
                    largeDesktopLineHeight="76.8px"
                    largeDesktopFontSize={64}
                    titleFontSize={42}
                    desktopLineHeight="50.4px"
                    noPadding
                    marginLeft={isDesktop ? 0 : 16}
                    component="h1"
                />
                <MapComponent
                    {...{ metadata, stations }}
                />
            </StyledCont>
        </StyledContainer>
    )
}
